import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { EFilters } from 'features/Filters';

interface IReportsSlice {
	chartFilters: Partial<Record<EFilters, string | null>>;
}

const initialState: IReportsSlice = {
	chartFilters: {
		offer_id: null,
		source_id: null,
		date_after: null,
		date_before: null,
	},
};

export const reportsSlice = createSlice({
	name: 'reports',
	initialState,
	reducers: {
		setFilter: (state, action: PayloadAction<{ name: EFilters; value: string | null }>) => {
			state.chartFilters[action.payload.name] = action.payload.value;
		},
	},
});

export default reportsSlice.reducer;
export const { setFilter } = reportsSlice.actions;
